import React from "react";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Imagini pentru galeria de curățenie generală
import generala1 from "assets/images/poze-site/7-1-generala.webp";
import generala2 from "assets/images/poze-site/7-2-generala.webp";
import generala3 from "assets/images/poze-site/7-3-generala.webp";
import generala4 from "assets/images/poze-site/7-4-generala.webp";
import generala5 from "assets/images/poze-site/7-5-generala.webp";
import generala6 from "assets/images/poze-site/7-6-generala.webp";
import generala9 from "assets/images/poze-site/7-9-generala.webp";

const images = [
    generala1,
    generala2,
    generala3,
    generala4,
    generala5,
    generala6,
    generala9,
];

function ServicesSection() {
    return (
        <MKBox py={6}>
            <Container>
                <MKTypography variant="h2" textAlign="center" mb={4}>
                    Galerie foto – Servicii de curățenie generală
                </MKTypography>

                <Grid container spacing={3} justifyContent="center">
                    {images.map((img, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <MKBox
                                component="div"
                                sx={{
                                    position: "relative",
                                    width: "100%",
                                    paddingTop: "70%", // raport fix (ex. 7:10). Poți schimba: 56.25% = 16:9, 100% = pătrat
                                    overflow: "hidden",
                                    borderRadius: "lg",
                                    boxShadow: 3,
                                }}
                            >
                                <MKBox
                                    component="img"
                                    src={img}
                                    alt={`Galerie curățenie generală ${index + 1}`}
                                    sx={{
                                        position: "absolute",
                                        inset: 0,
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                            </MKBox>
                        </Grid>
                    ))}
                </Grid>

                <MKButton
                    variant="gradient"
                    color="info"
                    size="large"
                    component="a"
                    href="/contact-curatenie"
                    sx={{ mt: 6, mx: "auto", display: "block" }}
                >
                    Solicită o vizită GRATUITĂ pentru ofertă!
                </MKButton>
            </Container>
        </MKBox>
    );
}

export default ServicesSection;
